<template>
  <div class="home">
    <v-row align="center">
      <v-col class="text-center">
        <v-img src="../assets/2026/header.png" />
      </v-col>
    </v-row>

    <v-row v-if="isAuthenticated">
      <v-col class="text-center">
        <p class="mb-2">Logged in as {{ user.full_name }} ({{ user.email }})</p>
        <small><a href="#" @click.prevent="logout">Is this not you?</a></small>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <h3>What is this about?</h3>
        <p>Dedicate Your Practice is an annual yoga charity drive where we set the intention of our practice towards a greater cause. The highest expression of the yoga journey is when we align our mind, body, and spirit in the service of others.</p>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <h3>How do I join?</h3>
        <ul class="oar-list">
          <li>Choose a charity to support</li>
          <li>Make a $10 donation</li>
          <li>Select class commitment</li>
        </ul>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <div class="round-block tan">
          <h3>In giving, we gain</h3>
          <p>Everyone who completes their commitment will:</p>
          <ul>
            <li>Have their donation matched by Ra - the more classes you commit to, the bigger the match!</li>
            <li>Be entered into our raffle to win one of three grand prizes.</li>
            <li>Receive an exclusive discount on a limited edition our Summer Tote Bag!</li>
          </ul>
        </div>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="6" class="mb-5">
        <v-btn
          v-if="!isAuthenticated"
          block
          x-large
          color="#A9421B"
          dark
          depressed
          :to="{ name: 'LoginSignupRoute' }">
          Let's Go!
        </v-btn>
        <v-btn
          v-if="isAuthenticated && !hasSignedUp"
          block
          x-large
          color="#A9421B"
          dark
          depressed
          :to="{ name: 'JoinRoute' }">
          Let's Go!
        </v-btn>
        <v-btn
          v-if="isAuthenticated && hasSignedUp"
          block
          x-large
          color="#A9421B"
          dark
          depressed
          :to="{ name: 'LeaderboardRoute' }">
          Check the leaderboard!
        </v-btn>
      </v-col>
    </v-row>
    
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// @ is an alias to /src

export default {
  name: 'Home',

  data() {
    return {
      confirmDialog: false,
      confirmCheckbox: false,
      isConfirmPending: false,
    }
  },

  components: {
  },

  computed: {
    ...mapGetters([
      'isAuthenticated',
      'hasSignedUp',
      'hasPaid'
    ]),
    user() {
      return this.$store.state.user
    },
  },

  methods: {
    openConfirmDialog() {
      this.confirmDialog = true
    },
    async createChallengeSignup() {
      this.isConfirmPending = true
      await this.$store.dispatch('createChallengeSignup', {
        challengeId: this.$store.state.challengeId,
        customerId: this.user.id,
        customerName: this.user.full_name,
        customerEmail: this.user.email,
        referral: this.$store.state.ref,
      })
      this.confirmDialog = false
      this.isConfirmPending = false

      this.$router.push('/challenge')
    },
    logout() {
      window.localStorage.removeItem('vuex')
      window.location.href = 'https://challenge.rayoga.com?prompt=1'
    },
  },

  mounted() {
    console.log(this.$route.query)
    if (this.$route.query.ref) {
      this.$store.state.ref = this.$route.query.ref
    }

    if (this.$route.query.prompt) {
      this.$store.state.prompt = true
    }

    if (this.hasSignedUp) {
      if (this.hasPaid) {
        this.$router.push('/leaderboard')
      } else {
        this.$router.push('/join')
      }
    }
  }
}
</script>

<style lang="scss">
h1,h2,h3,h4,h5,h6 {
  font-weight: bold;
}

.round-block {
  width: 100%;
  padding: 12px 15px;
  border-radius: 8px;

  &.tan {
    background-color: #F2EBDE;
  }

  ul {
    padding-left: 14px;
    li {
      margin-bottom: 10px;
    }
  }
}

ul.oar-list {
  padding-left: 43px;
  list-style-type: none;
  list-style-image: url('../assets/2026/icon-bee.png');

  li {
    padding-left: 10px;
    margin-bottom: 10px;
  }
}
</style>
